import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { TableHead } from '@material-ui/core';
import MUIToolbar from '@material-ui/core/Toolbar';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import DeleteIcon from '@material-ui/icons/Delete';
import '../components/Table/TableStiped.css';
import {
  deleteFeedback,
  fetchFeedback,
  highlightFeedback
} from 'features/FeedbackContainer/actions';
import { getMarketName } from 'features/app/selectors';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFeedback,
  // getFeedbackDeleted,
  // getFeedbackHighlight,
  getIsFetching
} from 'features/FeedbackContainer/selector';
import { toJS } from 'utils/immutableUtils';
// import { notify } from 'features/notificationSystem/actions';
import useAlert from 'features/alertSystem/hooks/useAlert';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)',
    overflowY: 'auto'
  },
  paper: {
    margin: '0 auto',
    minWidth: 800,
    maxWidth: 1980,
    height: '100%',
    padding: '10px'
  },
  title: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleInfo: {
    lineHeight: 1
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 300 // Ensure the search box has a reasonable width
  },
  inputRoot: {
    backgroundColor: '#fff',
    '& .MuiInputBase-root': {
      fontSize: '0.875rem'
    },
    '& input': {
      paddingTop: '12px',
      paddingBottom: '12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.1)'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderWidth: '1px'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  noDataText: {
    padding: theme.spacing(4),
    textAlign: 'center'
  }
}));
const formatDate = formulaCode => {
  return formulaCode.substring(0, 10);
};
const FeedbackListView = () => {
  // const [selectedRow, setSelectedRow] = useState(null);
  const currOrganization = useSelector(getMarketName);
  const feedback = useSelector(getFeedback);
  // const isHighlightFeedback = useSelector(getFeedbackHighlight);
  // const isDeletedFeedback = useSelector(getFeedbackDeleted);
  const isFetching = useSelector(getIsFetching);
  const [openAlert, closeAlert] = useAlert();

  const classes = useStyles();
  const dispatch = useDispatch();
  const feedbackList = toJS(feedback, []);
  // const highlightResponse = toJS(isHighlightFeedback, null);
  // const deletedResponse = toJS(isDeletedFeedback, null);

  const handleHighlightClick = (item, index) => {
    // setSelectedRow(index);
    dispatch(highlightFeedback(item.id));
  };
  const handleDeleteClick = item => {
    // dispatch(deleteFeedback(item.id));
    openAlert({
      title: 'Delete Message',
      content: 'Are you sure, you want to delete that message?',
      actions: {
        right: (
          <>
            <Button key="stay" onClick={closeAlert} color="primary">
              No
            </Button>
            <Button
              key="leave"
              onClick={() => {
                dispatch(deleteFeedback(item.id));
                closeAlert();
              }}
              color="secondary"
            >
              Yes
            </Button>
          </>
        )
      }
    });
  };

  // useEffect(() => {
  //   if (isHighlightFeedback) {
  //     dispatch(fetchFeedback(currOrganization));
  //     dispatch(
  //       notify({
  //         message: highlightResponse.message,
  //         variant: 'success'
  //       })
  //     );
  //     //setSelectedRow(feedbackList.findIndex(row => row.id === isHighlight));
  //   }
  // }, [isHighlightFeedback, currOrganization, dispatch]);
  // useEffect(() => {
  // if (isDeletedFeedback) {
  //   dispatch(fetchFeedback(currOrganization));
  //   closeAlert();
  //   dispatch(
  //     notify({
  //       message: deletedResponse.message,
  //       variant: 'success'
  //     })
  //   );
  //   //setSelectedRow(feedbackList.findIndex(row => row.id === isHighlight));
  // }
  // }, [isDeletedFeedback, currOrganization, dispatch]);

  useEffect(() => {
    dispatch(fetchFeedback(currOrganization));
  }, [currOrganization, dispatch]);

  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  return (
    <div className={classes.container}>
      <Paper className={classes.paper}>
        <MUIToolbar className={classes.root} data-testid="table-toolbar">
          <div className={classes.title} data-testid="table-toolbar-title">
            <Typography variant="h6">Feedback</Typography>
            <Typography variant="overline" className={classes.titleInfo}>
              <b>{feedbackList.length}</b> OBJECTS{' '}
              {!feedbackList.length ? ':(' : ''}
            </Typography>
          </div>
          {/* <div className={classes.flex}>
            <TextField
      id="table-search"
      placeholder={'Search...' }
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon className={classes.searchIcon} fontSize="small" />
          </InputAdornment>
        )
      }}
      onChange={handleSearchChange}
      classes={{ root: classes.inputRoot }}
      // value={query || ""}
    />
            </div> */}
        </MUIToolbar>

        {feedbackList.length > 0 ? (
          <div className="scrollable-table-container">
            <Table>
              <TableHead className="table-header">
                <TableRow>
                  <TableCell className="table-cell txtCenter">Date</TableCell>
                  <TableCell className="table-cell txtCenter">
                    Store ID
                  </TableCell>
                  <TableCell className="table-cell w50 txtCenter">
                    Message
                  </TableCell>
                  <TableCell className="table-cell txtCenter" colSpan={2}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {feedbackList.length > 0 &&
                  feedbackList.map((row, index) => (
                    <TableRow
                      key={index}
                      selected={row.isHighlighted}
                      className={`
                      ${index % 2 === 0 ? 'even-row' : 'odd-row'}
                      ${row.isHighlighted ? 'selected-row' : ''}
                    `}
                    >
                      <TableCell className="table-cell txtCenter">
                        {formatDate(row.feedbackDate)}
                      </TableCell>
                      <TableCell className="table-cell txtCenter">
                        {row.store}
                      </TableCell>
                      <TableCell className="table-cell w50">
                        {row.feedbackMessage}
                      </TableCell>
                      <TableCell className="table-cell txtCenter">
                        <Tooltip
                          title={
                            row.isHighlighted ? `De-highlight` : `Highlight`
                          }
                          arrow
                        >
                          <ReportProblemIcon
                            onClick={() => handleHighlightClick(row, index)}
                            className="reportIcon iconCol"
                          />
                        </Tooltip>
                      </TableCell>
                      <TableCell className="table-cell txtCenter">
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon
                            className="deleteicon iconCol"
                            onClick={() => handleDeleteClick(row)}
                          />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          !isFetching && (
            <Typography
              variant="subtitle2"
              classes={{ root: classes.noDataText }}
            >
              <FormattedMessage id="table.noDataLabel" />
            </Typography>
          )
        )}
      </Paper>
    </div>
  );
};

export default FeedbackListView;
